import { Checkbox, ColorPicker, Popper } from '@fourthwall/components';
import React, { useState } from 'react';
import tinycolor from 'tinycolor2';
import * as S from './styled';
export const ColorInput = ({ label, color, defaultColor, onChange }) => {
    const [isOpen, setOpen] = useState(false);
    return (React.createElement(Popper, { isOpen: isOpen, referenceComponent: React.createElement(S.Container, { onClick: () => setOpen((prevIsOpen) => !prevIsOpen) },
            React.createElement(S.ColorBoxContainer, null,
                React.createElement(S.ColorBox, { style: { backgroundColor: color || defaultColor } })),
            label), popperProps: {
            placement: 'bottom-start',
        }, style: { paddingTop: 8 }, onClose: () => setOpen(false) },
        React.createElement(ColorPicker, { color: color ? tinycolor(color).toRgbString() : defaultColor, position: "bottom-start", format: "RGB", showAlpha: true, hexVisible: true, onValueChange: onChange }),
        React.createElement(S.CheckboxContainer, null,
            React.createElement(Checkbox, { label: "Use site's default color", value: !color, onValueChange: (value) => {
                    if (value) {
                        onChange(undefined);
                    }
                    else {
                        onChange(defaultColor);
                    }
                } }))));
};
